import Vue from 'vue';
import VueRouter from 'vue-router';
import operacoes from '@/router/operacoes/index';
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils';
import { canNavigate } from '@/libs/acl/routeProtection';
import catalogoProdutos from '@/router/catalogo-produtos';
import relatorios from '@/router/relatorios';
import store from '@/store';
import auth from './routers/auth.router';
import cadastroGerais from './cadastros-gerais';
import cadastrosRoutes from './cadastros/cadastros.router';
import dkpCLientes from './dkp-clientes';
import sistemaRouter from './sistema';
import ptcRoutes from './ptcRoutes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: '', redirect: { name: 'home' } },
    ...cadastrosRoutes,
    ...auth,
    ...ptcRoutes,
    ...sistemaRouter,
    ...cadastroGerais,
    ...dkpCLientes,
    ...catalogoProdutos,
    ...operacoes,
    ...relatorios,
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/home/Index.vue'),
      meta: {
        action: 'read',
        resource: 'Auth',
      },
    },
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        pageTitle: 'Second Page',
      },
    },

    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
});

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn();
  const routesPublic = ['home'];
  if (routesPublic.includes(to.name) || !canNavigate(to) || !isLoggedIn) {
    if (!isLoggedIn) {
      store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', true);
      store.commit('appConfig/UPDATE_CONTENT_WIDTH', 'boxed');
    } else {
      store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', false);
      store.commit('appConfig/UPDATE_CONTENT_WIDTH', 'full');
    }
    return next();
  }
  if (!canNavigate(to)) {
    if (!isLoggedIn) return next({ name: 'login' });

    return next({ name: 'misc-not-authorized' });
  }

  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData();
    return next(getHomeRouteForLoggedInUser(userData ? userData.role : null));
  }

  return next();
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

export default router;
